import React from "react";

import { SimplePatientPageLayout } from "features/patients/components/SimplePatientPageLayout/SimplePatientPageLayout";

import { ConsultationsCard } from "./components/ConsultationsCard/ConsultationsCard.jsx";

const PatientConsultationsPage = () => (
  <SimplePatientPageLayout>
    <ConsultationsCard />
  </SimplePatientPageLayout>
);

export { PatientConsultationsPage };
